import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

// Also attach Bearer token if present (fallback when cookies blocked)
api.interceptors.request.use((config) => {
  const t = localStorage.getItem("uyap_token");
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export const authLogin = (username, phone) =>
  api.post("/auth/login", { username, phone }).then((r) => r.data);
export const authMe = () => api.get("/auth/me").then((r) => r.data);
export const authLogout = () => api.post("/auth/logout").then((r) => r.data);

export const listCases = () => api.get("/cases").then((r) => r.data);
export const createCase = (data) => api.post("/cases", data).then((r) => r.data);
export const updateCase = (id, data) => api.put(`/cases/${id}`, data).then((r) => r.data);
export const deleteCase = (id) => api.delete(`/cases/${id}`).then((r) => r.data);

export const bulkImportCases = (file) => {
  const fd = new FormData();
  fd.append("file", file);
  return api.post("/cases/import", fd, { headers: { "Content-Type": "multipart/form-data" } }).then((r) => r.data);
};

export const listDocuments = (caseId, sub) =>
  api.get(`/cases/${caseId}/documents`, { params: sub ? { sub_account: sub } : {} }).then((r) => r.data);
export const uploadDocument = (caseId, subAccount, file) => {
  const fd = new FormData();
  fd.append("sub_account", subAccount);
  fd.append("file", file);
  return api.post(`/cases/${caseId}/documents`, fd, { headers: { "Content-Type": "multipart/form-data" } }).then((r) => r.data);
};
export const deleteDocument = (id) => api.delete(`/documents/${id}`).then((r) => r.data);
export const downloadDocumentUrl = (id) => {
  const t = localStorage.getItem("uyap_token");
  return `${API}/documents/${id}/download${t ? `?auth=${encodeURIComponent(t)}` : ""}`;
};

export const listPayments = (caseId) => api.get(`/cases/${caseId}/payments`).then((r) => r.data);
export const addPayment = (caseId, data) => api.post(`/cases/${caseId}/payments`, data).then((r) => r.data);
export const deletePayment = (id) => api.delete(`/payments/${id}`).then((r) => r.data);

export const getInstallments = (caseId) => api.get(`/cases/${caseId}/installments`).then((r) => r.data);
const _mq = (mt) => (mt && mt !== "tum" ? `?mahkeme_turu=${encodeURIComponent(mt)}` : "");
export const installmentAlerts = (mt) => api.get(`/reports/installment_alerts${_mq(mt)}`).then((r) => r.data);

export const listCaseHearings = (caseId) => api.get(`/cases/${caseId}/hearings`).then((r) => r.data);
export const createHearing = (caseId, data) => api.post(`/cases/${caseId}/hearings`, data).then((r) => r.data);
export const listHearings = (month) => api.get(`/hearings`, { params: month ? { month } : {} }).then((r) => r.data);
export const updateHearing = (id, data) => api.put(`/hearings/${id}`, data).then((r) => r.data);
export const deleteHearing = (id) => api.delete(`/hearings/${id}`).then((r) => r.data);

export const financialReport = (mt) => api.get(`/reports/financial${_mq(mt)}`).then((r) => r.data);
export const successReport = (mt) => api.get(`/reports/success${_mq(mt)}`).then((r) => r.data);
export const karsiVekaletPending = (mt) => api.get(`/reports/karsi_vekalet_pending${_mq(mt)}`).then((r) => r.data);

export const casePdfUrl = (caseId) => {
  const t = localStorage.getItem("uyap_token");
  return `${API}/cases/${caseId}/report.pdf${t ? `?auth=${encodeURIComponent(t)}` : ""}`;
};

export const backupSummary = () => api.get("/backup/summary").then((r) => r.data);
export const backupZipUrl = (year) => {
  const t = localStorage.getItem("uyap_token");
  const params = new URLSearchParams();
  if (year) params.set("year", year);
  if (t) params.set("auth", t);
  const qs = params.toString();
  return `${API}/backup.zip${qs ? `?${qs}` : ""}`;
};
